<template>
    <div class="mbody tbody">
        <h1 style="justify-content: center;display: flex;" class="tit">MINT</h1>

        <hr class="rounded">

        <CoalDialogVue></CoalDialogVue>

        <div v-bind:class="baphclass" class="mint">
            <div class="baph">

                <img style="width: 100%" src="../../assets/a2.png" />
                <div class="texholder">

                    <div>Mint</div>
                    <div>Price : {{ calc_pris }} $KDA + Soul</div>
                    <br>
                    <button class="msig" @click="sign_deal()" v-bind:disabled="is_loading">
                        <div v-show="!is_loading">SIGN</div>
                        <LoadingCompVue v-show="is_loading"></LoadingCompVue>
                    </button>

                </div>
            </div>
            <div class="">

            </div>

        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';
import LoadingCompVue from '../LoadingComp.vue';
import { get_account, MintNFT, get_nft_manager, mypolling, SigningError, InsufficientFundsError, vget } from '@/utility'
import CoalDialogVue from './CoalDialog.vue';


export default {
    name: ENUMS.VIEWS.MAIN
    , data() {
        return {
            ENUMS: ENUMS
            , is_loading: false
            , dialog_message: undefined
            , baphclass: ""
        }
    }, computed: {
        calc_pris() {
            var res = "13.69"
            var qthis = this
            try {

                if (vget(qthis.$store.state.wallet_manager, "network_id") == "testnet04") {
                    res = "6.66 (testnet)"
                }
            } catch (error) {
                console.log("nothing")
            }
            return res
        }
    }
    , components: { LoadingCompVue, CoalDialogVue }, methods: {
        sign_deal: function () {
            var mintsnd = new Audio('/mint.mp3');
            var eviafsnd = new Audio('/evilaf.mp3');


            var qthis = this
            qthis.is_loading = true


            get_nft_manager(qthis).then((x) => x.mint_coal()).catch((e) => {
                if (e instanceof SigningError) {
                    qthis.dialog_message = "User rejected transaction"
                } else if (e instanceof InsufficientFundsError) {
                    qthis.dialog_message = "Insufficient Funds"
                } else {
                    console.log("5%%%%%", e, typeof x)
                }
                throw e

            }).then(x => {
                if (x instanceof MintNFT) {
                    mintsnd.play();
                    setTimeout(() => {
                        eviafsnd.play()
                        qthis.baphclass = "bascale"

                    }, 500);
                    setTimeout(() => {
                        qthis.$store.commit("changeView", ENUMS.VIEWS.MYNFTS)

                    }, 1500);
                } else {
                    qthis.dialog_message = x
                }
                console.log("&&&&&&&", x)
            }).finally(() => {
                qthis.is_loading = false
            })

        }
        , get_account
        , get_nft_manager
        , mypolling
        , SigningError
        , InsufficientFundsError
        , MintNFT
    }
}

</script>

<style scoped>
.bascale {
    transition: 1s;
    transform: scale(100) translate(0px, 200px);
    opacity: 0%;
}

.bafolder {
    display: flex;
    justify-content: center;
    align-items: center;
}

.baph {
    width: 500px;
}

.mint {
    display: flex;
    justify-content: center;
    padding-top: 2%;
}

.texholder {
    position: relative;
    top: -35%;
    left: 2%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-shadow: 4px 4px #ff0000;
    animation: texanim 5s infinite forwards;
}

@keyframes texanim {
    0% {
        text-shadow: 0px 0px #ff0000;
    }

    10% {
        text-shadow: 0px 0px #ff0000;
    }

    20% {
        text-shadow: 8px 0px #7c0606;
    }


    30% {
        text-shadow: 0px 0px #ff0000;
    }

    50% {
        text-shadow: -8px 0px #7a1d1d;
    }

    70% {
        text-shadow: 0px 0px #ff0000;
    }

    85% {
        text-shadow: 0px -5px #f17878;
    }


    100% {
        text-shadow: 0px 0px #ff0000;
    }

}

.tbody {
    padding: 5%;
}

.msig {
    width: 50%;
    color: rgb(255, 0, 0);
    border-color: rgb(112, 18, 18);
    padding: 3%;
    transition: 0.7s;
    animation: sigcol 2s infinite forwards;
}

@keyframes sigcol {
    0% {
        border-color: rgb(112, 18, 18);

    }

    80% {
        border-color: white;

    }

    100% {
        border-color: rgb(112, 18, 18);
    }

}

.msig:hover {
    border-color: white;
    transform: translate(0px, 0px) scale(1.1);
    /* box-shadow: 10px 10px black; */
    color: rgb(255, 255, 255);
}
</style>